/**
 * Encoding Utilities
 *
 * Utilities for encoding sensitive data using AES encryption
 */

// @ts-ignore - crypto-js types not installed
import CryptoJS from 'crypto-js';
import { reservedCharactersAlias } from '../../constants/reservedCharacters';
import { getUserEncrypted } from './storageUtils';

const IV_KEY = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

/**
 * Format encryption key from token
 */
const formatKey = (token: string): string => {
  return token.slice(-8);
};

/**
 * Encoding class for AES encryption with special character replacement
 */
class Encrypt {
  /**
   * Encode data using AES encryption
   * @param data - Data to encode
   * @param encodeKey - Optional encoding key (defaults to user email)
   */
  static encode(data: string, encodeKey?: string): string {
    const user = getUserEncrypted();
    const codeKey = formatKey(encodeKey ?? user.mail);

    if (!codeKey) {
      throw new Error(`Unable to encode without a valid codeKey: ${codeKey}`);
    }

    const cryptKey = CryptoJS.enc.Utf8.parse(String(codeKey));
    const cipher = CryptoJS.AES.encrypt(String(data), cryptKey, {
      iv: IV_KEY,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });

    const replaceCipher = this.encodeReservedCharacters(cipher.toString());
    return encodeURIComponent(replaceCipher);
  }

  /**
   * Replace reserved characters with aliases
   */
  static encodeReservedCharacters(param: string): string {
    return param
      .replace(/\+/g, reservedCharactersAlias.plus)
      .replace(/\//g, reservedCharactersAlias.forwardSlash)
      .replace(/=/g, reservedCharactersAlias.equal);
  }
}

export default Encrypt;
